import { render, staticRenderFns } from "./CreditLicensesForm.vue?vue&type=template&id=11971cf6&"
import script from "./CreditLicensesForm.vue?vue&type=script&lang=js&"
export * from "./CreditLicensesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports